'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeaderPrimaryStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  first: _propTypes2.default.bool,
  last: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
  theme: _propTypes2.default.object
};
var defaultProps = {
  first: false,
  last: false,
  size: 'default'
};
/** Prop Receivers */

var sizeProps = function sizeProps(_ref) {
  var themeFromProvider = _ref.theme,
      first = _ref.first,
      last = _ref.last,
      size = _ref.size;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.card.headerPrimary.size[size],
      paddingX = _theme$reactackle$com.paddingX,
      paddingY = _theme$reactackle$com.paddingY,
      paddingYLarge = _theme$reactackle$com.paddingYLarge,
      similarElementsSpacing = _theme$reactackle$com.similarElementsSpacing;
  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    \n    ' + (first && 'padding-top: ' + (0, _reactackleCore.getValueString)(paddingYLarge) + ';') + '\n    ' + (last && 'padding-bottom: ' + (0, _reactackleCore.getValueString)(paddingYLarge) + ';') + '\n    \n    & + & {\n      padding-top: ' + (0, _reactackleCore.getValueString)(similarElementsSpacing) + ';\n    }\n  ';
};
/** Styles */


var CardHeaderPrimaryStyled = exports.CardHeaderPrimaryStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardHeaderPrimaryStyled'
})(['display:flex;', ';'], sizeProps);

CardHeaderPrimaryStyled.propTypes = propTypes;
CardHeaderPrimaryStyled.defaultProps = defaultProps;
CardHeaderPrimaryStyled.displayName = 'CardHeaderPrimaryStyled';